import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-070de6d2"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-h6" }, "Desabilitar Usuário", -1))
const _hoisted_2 = ["innerHTML"]

import { api } from '@/utils';
import useQuasar from 'quasar/src/composables/use-quasar.js';;
import { User } from '@/models/user';
import { computed, ref } from 'vue';

interface Props {
  user: User | null;
}

interface Emits {
  (e: 'open'): void;
  (e: 'close'): void;
  (e: 'saved'): void;
}


export default /*#__PURE__*/_defineComponent({
  props: {
    user: null
  },
  emits: ["open", "close", "saved"],
  setup(__props: any, { expose, emit }: { emit: ({
  (e: 'open'): void;
  (e: 'close'): void;
  (e: 'saved'): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  user: User | null;
}




const quasar = useQuasar();

const show = ref<boolean>(false);

const message = computed(() => {
  if (props.user?.deletedAt) {
    return `Realmente deseja reabilitar o usuário <strong>${props.user?.name}</strong>?`;
  } else {
    return `Realmente deseja desabilitar o usuário <strong>${props.user?.name}</strong>?`;
  }
});

const disable = () => {
  api
    .delete(`user/${props.user?.id}`)
    .then(() => {
      quasar.notify({
        type: 'positive',
        message: 'Usuário desabilitado!',
      });

      close();
      emit('saved');
    })
    .catch((error) => {
      quasar.notify({
        type: 'negative',
        message: error.response.data.message,
      });

      console.log('Erro ao salvar usuário.', error.response);
    });
};

const enable = () => {
  api
    .get(`user/${props.user?.id}/restore`)
    .then(() => {
      quasar.notify({
        type: 'positive',
        message: 'Usuário reabilitado!',
      });

      close();
      emit('saved');
    })
    .catch((error) => {
      quasar.notify({
        type: 'negative',
        message: error.response.data.message,
      });

      console.log('Erro ao salvar usuário.', error.response);
    });
};

const confirm = () => {
  if (props.user?.deletedAt) {
    enable();
  } else {
    disable();
  }
};

const open = () => {
  show.value = true;
  emit('open');
};

const close = () => {
  show.value = false;
  emit('close');
};

expose({ open, close });

return (_ctx: any,_cache: any) => {
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_card_actions = _resolveComponent("q-card-actions")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_q_dialog = _resolveComponent("q-dialog")!

  return (_openBlock(), _createBlock(_component_q_dialog, {
    modelValue: show.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((show).value = $event)),
    persistent: ""
  }, {
    default: _withCtx(() => [
      _createVNode(_component_q_card, { class: "view-modal" }, {
        default: _withCtx(() => [
          _createVNode(_component_q_card_section, null, {
            default: _withCtx(() => [
              _hoisted_1
            ]),
            _: 1
          }),
          _createVNode(_component_q_card_section, null, {
            default: _withCtx(() => [
              _createElementVNode("p", { innerHTML: _unref(message) }, null, 8, _hoisted_2)
            ]),
            _: 1
          }),
          _createVNode(_component_q_card_actions, { align: "right" }, {
            default: _withCtx(() => [
              _createVNode(_component_q_btn, {
                flat: "",
                label: "Não",
                onClick: close
              }),
              _createVNode(_component_q_btn, {
                flat: "",
                label: "Sim",
                onClick: confirm
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})